import React from "react";
import { hideLeftPaneButton as Strings_hideLeftPaneButton, showLeftPaneButton as Strings_showLeftPaneButton, } from "../strings/toggleLeftPaneButton.locstring.json";
import loc from "owa-localize";
import { observer } from "owa-mobx-react";
import { ToggleButton } from "./ToggleButton";

type ExtraTopRibbonControlsBeforeTabsProps = {
    isExpanded: boolean;
    onClick: () => void;
};

export const ExtraTopRibbonControlsBeforeTabs: React.FunctionComponent<ExtraTopRibbonControlsBeforeTabsProps> = observer(({ isExpanded, onClick }: ExtraTopRibbonControlsBeforeTabsProps) => {
    const sharedProps = {
        label: loc(isExpanded ? Strings_hideLeftPaneButton : Strings_showLeftPaneButton),
        onClick,
    };
    
    return <ToggleButton {...sharedProps}/>;
}, "ExtraTopRibbonControlsBeforeTabs");
